module.exports = __webpack_public_path__ + "static/media/Plantilla-73.78e048d6.svg";